<form [formGroup]="form">
  <div class="box form-organization-group">
    <h2 class="title is-3" i18n>General Details</h2>
    <label class="field">
      <div class="label" i18n>Group name</div>
      <div class="control">
        <input
          class="input"
          [formControl]="name"
          data-e2e="input-group-name"
          type="text"
          [ngClass]="{ 'is-danger': isInvalid(name) }"
        />
        <portal-form-error [formInput]="name" errorId="name"></portal-form-error>
      </div>
    </label>
    <div class="box__separator"></div>
    <div>
      <div class="rows">
        <div class="row box is-shadowless is-borderless p-2">
          <h2 class="title is-3" i18n>Access Rights</h2>
          <label class="field">
            <div class="label" i18n>Parent Organization</div>
            <ng-container *ngIf="!groupModeEdit">
              <portal-hierarchy-single-select
                [control]="parentEntityUid"
                [organizationGroup]="true"
                [displayOptionApplyAndClear]="true"
                data-e2e="user-hierarchy-select"
                (selectedOrganisationAfterApply)="onSelectedOrganisation($event)"
                (selectedAllDescendantsOfEntity)="setSelectedParentEntityIDs($event)"
              ></portal-hierarchy-single-select>
              <portal-form-error
                [formInput]="parentEntityUid"
                errorId="entityUid"
              ></portal-form-error>
            </ng-container>
            <ng-container *ngIf="groupModeEdit">
              <div class="box has-background-white-bis is-shadowless p-2">
                <span>{{ onSetControlParentEntityUidValue() }}</span>
                <span
                  class="button is-static has-background-info-lighter has-text-grey-darker is-borderless"
                  >{{ groupViewDetailEdit?.parentOrganization?.name || '-' }}</span
                >
              </div>
            </ng-container>
          </label>
        </div>
        <div class="row box is-shadowless is-borderless p-2">
          <div class="field" *ngIf="selectedParentEntity">
            <label class="label" i18n>Organizations</label>
            <div class="help is-danger">
              <p *ngIf="selectedEntityListGroupOrganisation?.length > maximumLimitOrgToAdd" i18n>
                {{ messageMaximumLimitOrgReached }}
              </p>
              <p *ngIf="isParentSelection" i18n>
                {{ messageExpandOrganizationDropDown }}
              </p>
              <p *ngIf="!isParentSelection && !isParentEntityToExclude && selectedEntityListGroupOrganisation?.length < minimumLimitOrgToAdd" i18n>
                {{ messageMinimumLimitOrgReached }}
              </p>
              <p *ngIf="isParentEntityToExclude" i18n>
                {{ messageParentEntityNotIncluded }}
              </p>
            </div>

            <portal-hierarchy-filters
              [control]="entityUids"
              [selectedEntities]="searchPayload.criteriaMap"
              [numberOfSelectedEntities]="100"
              [isMainDropdownFilter]="true"
              [organizationGroup]="true"
              [selectedParentEntity]="selectedParentEntity"
              [selectedParentEntityChanged]="selectedParentEntityChanged"
              [groupModeEdit]="groupModeEdit"
              [selectedSubOrgToEdit]="groupViewDetailEdit?.subOrganizations"
              [isDropdownHeight]="true"
              [isPreSelectedOrganizationNumber]="preSelectedOrganizationNumber"
              [disabledApply]="isApplyDisabled"
              (resetParentEntityChanged)="onResetParentEntityChanged()"
              (filterApplied)="onFilterApplied($event)"
              (staticFilterUpdated)="onStaticFilterUpdated($event)"
              (allPreSelectedEntitiesNumber)="onAllPreSelectedEntitiesNumber($event)"
              (isParentSelectedEmitter)="onParentSelection($event)"
              (filterAppliedSelectedEntities)="onFilterAppliedSelectedEntities($event)"
              (entityListGroupOrganisationUpdated)="setEntityListGroupOrganisation($event)"
            ></portal-hierarchy-filters>
          </div>
        </div>

        <div class="box__separator" *ngIf="selectedParentEntity && isGroupHierarchyRestrictByActive"></div>
        <!-- Group By Section -->
        <div class="row box is-shadowless is-borderless p-2" *ngIf="selectedParentEntity && isGroupHierarchyRestrictByActive">
          <!-- Group By Dropdown -->
          <div class="field">
            <portal-select-control
              name="Additionally restrict by"
              i18n-name
              [optional]="true"
              [control]="groupBy"
              [options]="groupByOptions"
              placeholder="- Restrict by -"
              i18n-placeholder
              [e2eName]="'select-group-by'"
              [e2eErrorName]="'group-by-error'"
            ></portal-select-control>
          </div>

          <!-- Select Acquirers/Processors Dropdown -->
          <div class="field" *ngIf="groupBy.value">
            <portal-select-control
              [name]="groupBy.value === 'acquirers' ? 'Select acquirer' : 'Select processor'"
              i18n-name
              [control]="selectedItems"
              [options]="groupBy.value === 'acquirers' ? acquirerOptions : processorOptions"
              [placeholder]="groupBy.value === 'acquirers' ? '- Select acquirer -' : '- Select processor -'"
              i18n-placeholder
              [e2eName]="'select-items'"
              [e2eErrorName]="'selected-items-error'"
            ></portal-select-control>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="box__separator"></div>

  <div
    class="columns is-vcentered is-flex is-variable is-2-mobile is-3-tablet is-4-desktop is-4-widescreen is-4-fullhd"
  >
    <div class="column">
      <ng-container *ngIf="!groupModeEdit">
        <button
          class="button has-text-danger is-text"
          data-e2e="link-cancel-organization-group"
          *restrictPermission="['cancel-organization-group']"
          [routerLink]="['/administration', 'users']"
          i18n
          title="Click to cancel"
          type="button"
          i18n-title
        >
          Cancel
      </button>
      </ng-container>
      <ng-container *ngIf="groupModeEdit">
        <button
          class="button has-text-danger is-text"
          data-e2e="link-discard-cancel-organization-group"
          *restrictPermission="['discard-changes-organization-group']"
          (click)="onCancel()"
          i18n
          title="Discard changes"
          type="button"
          i18n-title
        >
          Discard changes
        </button>
      </ng-container>
    </div>
    <div class="column has-text-right">
      <button
        *restrictPermission="['save-organization-group']"
        type="submit"
        class="button is-primary"
        [class.is-loading]="isSaving"
        data-e2e="button-submit-organization-group"
        (click)="submit()"
        [disabled]="
          !form.valid || isButtonDisabled || selectedEntityListGroupOrganisation?.length < minimumLimitOrgToAdd || selectedEntityListGroupOrganisation?.length > maximumLimitOrgToAdd
        "
        title="Save"
        i18n-title
      >
        <span *ngIf="!groupModeEdit" i18n>Save</span>
        <span *ngIf="groupModeEdit" i18n>Save changes</span>
      </button>
    </div>
  </div>
</form>

<portal-base-modal #cancelModal>
  <div title i18n>Are you sure you want to discard your changes?</div>
  <div class="level" buttons>
    <div class="level-left"></div>
    <div class="buttons">
      <button
        type="button"
        class="button is-outlined"
        (click)="cancelModal.close()"
        i18n
        data-e2e="delete-blocking-ruleset-confirm"
        title="No"
        i18n-title
      >
        No
      </button>
      <button
        type="button"
        class="button is-primary"
        data-e2e="cancel-modal-confirmed"
        (click)="onCancelModalConfirmed()"
        i18n
        title="Yes"
        i18n-title
      >
        Yes
      </button>
    </div>
  </div>
</portal-base-modal>
